import { Button } from '@/components/ui/button';
import { useTouchHandlerName } from '@/hooks/utilities/use-mobile';
import classNames from '@/lib/misc/classNames';
import { FaArrowLeft } from 'react-icons/fa';
interface NumberPadProps {
  className?: string;
  usdValue: string;
  handleNumPadUsdChange: (_: string) => void;
  handleNumPadTokenChange: (_: string) => void;
  isSwitched: boolean;
  tokenAmount: string;
  disablePads: boolean;
}
export default function Keypad({
  className,
  usdValue,
  handleNumPadUsdChange,
  handleNumPadTokenChange,
  isSwitched,
  tokenAmount,
  disablePads
}: NumberPadProps) {
  const realValue = isSwitched ? tokenAmount : usdValue;
  const handleClickNumPad = (pad: string) => {
    const newValue = handleNumberPadInput(pad);
    isSwitched ? handleNumPadTokenChange(newValue) : handleNumPadUsdChange(newValue);
  };
  const touchHandlerName = useTouchHandlerName();
  const handleNumberPadInput = (pad: string): string => {
    if (pad === '.') {
      const index = realValue.indexOf('.');
      if (index >= 0) {
        return realValue;
      }
    } else {
      if (realValue === '0') {
        return pad;
      }
    }
    return realValue + pad;
  };
  const handleDeleteInput = (): string => {
    if (usdValue === '0') {
      return usdValue;
    } else {
      return realValue.substring(0, realValue.length - 1);
    }
  };
  const handleClickDelete = () => {
    const newValue = handleDeleteInput();
    isSwitched ? handleNumPadTokenChange(newValue) : handleNumPadUsdChange(newValue);
  };
  return <div className={classNames('w-full grid gap-4 grid-cols-3 text-2xl justify-items-center', className)} data-sentry-component="Keypad" data-sentry-source-file="Keypad.tsx">
      <Button type='button' disabled={disablePads} variant='ghost' className='text-genius-cream w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickNumPad('1');
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        1
      </Button>
      <Button type='button' disabled={disablePads} variant='ghost' className='text-genius-cream w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickNumPad('2');
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        2
      </Button>
      <Button type='button' disabled={disablePads} variant='ghost' className='text-genius-cream w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickNumPad('3');
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        {3}
      </Button>
      <Button type='button' disabled={disablePads} variant='ghost' className='text-genius-cream w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickNumPad('4');
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        {4}
      </Button>
      <Button type='button' disabled={disablePads} variant='ghost' className='text-genius-cream w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickNumPad('5');
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        {5}
      </Button>
      <Button type='button' disabled={disablePads} variant='ghost' className='text-genius-cream w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickNumPad('6');
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        {6}
      </Button>
      <Button type='button' disabled={disablePads} variant='ghost' className='text-genius-cream w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickNumPad('7');
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        {7}
      </Button>
      <Button type='button' disabled={disablePads} variant='ghost' className='text-genius-cream w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickNumPad('8');
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        {8}
      </Button>
      <Button type='button' disabled={disablePads} variant='ghost' className='text-genius-cream w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickNumPad('9');
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        {9}
      </Button>
      <Button type='button' disabled={disablePads} variant='ghost' className='text-genius-cream w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickNumPad('.');
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        {'.'}
      </Button>
      <Button type='button' disabled={disablePads} variant='ghost' className='text-genius-cream w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickNumPad('0');
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        {0}
      </Button>
      <Button type='button' variant='ghost' className='text-genius-cream/50 w-1/3 text-center duration-300 text-[20px] transition-all py-3 px-4 flex items-center justify-center md:hover:bg-transparent' {...{
      [touchHandlerName]: () => {
        handleClickDelete();
      }
    }} data-sentry-element="Button" data-sentry-source-file="Keypad.tsx">
        {/* <FaArrowLeft
                 size={40}
         className='!important text-[20px] text-genius-cream/50'/> */}
        ←
      </Button>
    </div>;
}